import './App.css';
import './Pages/css/main.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';
import Sidebar from './Pages/nav/sidebar';

import Dashboard from './Pages/dashboard';
import Login from './Pages/login';
import Sugi from './Pages/sugi';
import Paylist from './Pages/paylist';
import Notice from './Pages/notice';
import Settlement from './Pages/settlement';
import CreateMerchant from './Pages/createMerchant';

import ErrorBoundary from './Pages/common/ErrorBoundary'
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { change_hostLogoImg } from './store';

function App() {
  console.error = (message) => {
    // if (message.startsWith('Warning: ...')) {
    //   return; // 특정 경고 무시
    // }
    // originalConsoleError(message);
  };

  let location = useLocation();
  let dispatch = useDispatch();

  useEffect(() => {
    if (window.location.hostname == "cp.onu-terminal.com") {
      dispatch(change_hostLogoImg("onu"))
    }
    else {
      dispatch(change_hostLogoImg("fast"))
    }
  }, [])

  return (
    <div className="App" style={{ maxWidth: "1920px", margin: "0 auto" }}>
      <div className="py-0 md:py-5 header">
        <Header />
        <div className='section1'>
          <Sidebar />
          <div className={`section2 ${location.pathname == '/' ? "main" : ""}`}>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Login />} />
                {/* <Route path="/dashboard" element={<Paylist />} /> */}
                {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                {JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                  ?
                  <Route path="/sugi" element={<Sugi />} />
                  : ""}
                <Route path="/paylist" element={<Paylist />} />
                <Route path="/notice" element={<Notice />} />
                <Route path="/settlement" element={<Settlement />} />
                {/* <Route path="/createMerchant" element={<CreateMerchant />} /> */}

                {JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                  ?
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                  :
                  <Route path="*" element={<Navigate to="/paylist" />} />
                }
              </Routes>
            </ErrorBoundary>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
